<div class="search-group">
  <fuse-date-range-filter></fuse-date-range-filter>
  <fuse-driver-filter></fuse-driver-filter>
  <fuse-order-type-filter></fuse-order-type-filter>
</div>
<div class="search-group">
  <fuse-opinion-filter></fuse-opinion-filter>
  <fuse-only-with-comment-filter></fuse-only-with-comment-filter>
</div>
